import { Separator } from "@components/common/separator"
import { Card, CardContent, CardHeader, CardTitle } from "@components/common/card"
import axios from "axios"
import { FileItems } from "@pma/types"
import PmsLoader from "@components/common/loader"
import { Button } from "@components/common/button"
import { useInfiniteQuery } from "@tanstack/react-query"
import { SERVER_URL } from "@pma/utils/api-routes"
import { parseCookies } from "nookies"
import { ACCESS_TOKEN } from "@pma/utils/constants"
import { useAuth } from "@stores/auth-store"
import { FileCard } from "../files/file-card"
import useTranslator from "@hooks/use-translator"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { useEffect } from "react"

const LatestFiles = () => {
  const { translate } = useTranslator()

  const location = useLocation()
  const navigate = useNavigate()

  const { authConfig } = useAuth()
  const orgId = authConfig?.last_organization_id

  const [searchParam] = useSearchParams()
  const queryKey = searchParam.get("revalidate")

  const accessToken = parseCookies()[ACCESS_TOKEN]
  const getFiles = async ({ pageParam = 1 }) => {
    const response = await axios.get(
      SERVER_URL +
        `/files/getAll/byCurrentUser?deleted=false&paging_start_page=${pageParam}&paging_per_page=${10}&organization_id=${orgId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      },
    )
    return response.data
  }

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetching,
    isFetchingNextPage,
    refetch
  } = useInfiniteQuery({
    queryKey: ["get-files"],
    queryFn: ({ pageParam = 1 }) => getFiles({ pageParam }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage?.nextPage) {
        return undefined
      }
      return allPages.length + 1
    },
  })

  const handleLoadMoreData = async () => {
    await fetchNextPage()
  }

  const isEmpty = !data?.pages[0]?.itemsReceived

  useEffect(() => {
    if (queryKey === "projects") {
      refetch()
      navigate(`${location.pathname}`)
    }
  }, [queryKey])

  return (
    <Card className='flex h-[70vh] flex-col items-center gap-2'>
      <CardHeader className='border-b-2 border-primary'>
        <CardTitle className='w-fit'>{translate("Latest Files")}</CardTitle>
      </CardHeader>
      <Separator />
      <CardContent className='flex w-full flex-col gap-3 overflow-y-auto overflow-x-hidden px-2'>
        {isLoading ? (
          <div style={{ width: "100%" }}>
            <PmsLoader />
          </div>
        ) : (
          <>
            {data &&
              data.pages?.map((page) =>
                page?.items?.map((file: FileItems) => <FileCard file={file} key={file.id} />),
              )}

            {isEmpty && !isFetching && (
              <small className='flex h-full w-full items-center justify-center'>
                {translate("No Files found")}
              </small>
            )}
            {isFetchingNextPage && (
              <div style={{ width: "100%" }}>
                <PmsLoader />
              </div>
            )}
            {hasNextPage ? (
              <Button variant={"link"} className='text-primary' onClick={handleLoadMoreData}>
                {translate("Load More")}
              </Button>
            ) : null}
          </>
        )}
      </CardContent>
    </Card>
  )
}

export default LatestFiles
